// Écran « Mon compte » : ce que JE suis, et mon mot de passe.
//
// POURQUOI IL EXISTE. Le changement de mot de passe vivait dans l'écran
// « Utilisateurs », réservé aux administrateurs. Un travailleur d'atelier
// n'avait donc AUCUN moyen de changer le sien — alors que c'est justement lui
// qui l'a reçu de vive voix d'un collègue, et qui devrait le remplacer tout de
// suite. Le super-admin avait le même trou, dans son propre espace.
//
// Un mot de passe qu'on ne peut pas changer soi-même finit par être partagé.
import { useState } from "react";

import api from "../api";
import Layout from "../components/Layout";
import ChampMotDePasse from "../components/ChampMotDePasse";
import { formaterDate } from "../format";

const LIBELLES_ROLE = {
  travailleur: "Travailleur",
  admin: "Administrateur",
  superadmin: "Éditeur",
};

// Reprise du texte de la politique serveur (auth.valider_mot_de_passe). Affiché
// pour guider, PAS pour valider : le serveur reste seul juge, et c'est lui qui
// renvoie le motif exact du refus. Un contrôle ici ne protégerait rien — il
// suffit d'appeler l'API directement pour le contourner.
const AIDE_MOT_DE_PASSE =
  "12 caractères minimum, sans suite prévisible (1234, abcd), " +
  "sans mot courant, et sans votre adresse e-mail.";

function messageErreur(err, defaut) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return defaut;
}

export default function MonCompte({ user, onLogout }) {
  const [ancien, setAncien] = useState("");
  const [nouveau, setNouveau] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState("");
  const [message, setMessage] = useState("");

  const changer = (e) => {
    e.preventDefault();
    // Seule vérification faite ici, et elle ne remplace aucun contrôle
    // serveur : elle attrape la faute de frappe avant de couper les sessions
    // de l'utilisateur avec un mot de passe qu'il croit connaître.
    if (nouveau !== confirmation) {
      setErreur("Les deux saisies ne correspondent pas.");
      return;
    }
    setEnCours(true);
    setErreur("");
    api
      .post("/me/mot-de-passe", {
        ancien_mot_de_passe: ancien,
        nouveau_mot_de_passe: nouveau,
      })
      .then(({ data }) => {
        // Le serveur rend un jeton neuf, émis au seuil de révocation qu'il
        // vient de poser. Sans cette ligne on garderait l'ancien — invalide
        // dans la seconde — et on serait déconnecté par son propre changement
        // de mot de passe.
        if (data?.access_token) localStorage.setItem("token", data.access_token);
        setAncien("");
        setNouveau("");
        setConfirmation("");
        setMessage(
          "Mot de passe changé. Vos autres sessions ont été déconnectées."
        );
        setTimeout(() => setMessage(""), 8000);
      })
      .catch((err) => setErreur(messageErreur(err, "Changement impossible.")))
      .finally(() => setEnCours(false));
  };

  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="entete-page">
        <h1>Mon compte</h1>
      </div>

      {message && <p className="note-succes">{message}</p>}

      <section className="carte">
        <div className="entete-section">
          <h3>Mes informations</h3>
        </div>
        <div className="grille-champs">
          <div className="champ">
            <span className="champ-label">Prénom</span>
            <span className="champ-valeur">{user.prenom}</span>
          </div>
          <div className="champ">
            <span className="champ-label">Nom</span>
            <span className="champ-valeur">{user.nom}</span>
          </div>
          <div className="champ">
            <span className="champ-label">E-mail</span>
            <span className="champ-valeur">{user.email}</span>
          </div>
          <div className="champ">
            <span className="champ-label">Rôle</span>
            <span className="champ-valeur">
              {LIBELLES_ROLE[user.role] || user.role}
            </span>
          </div>
          {user.date_creation && (
            <div className="champ">
              <span className="champ-label">Compte ouvert le</span>
              <span className="champ-valeur">
                {formaterDate(user.date_creation)}
              </span>
            </div>
          )}
        </div>
        <p className="sous-info">
          {/* Dire QUI corrige quoi évite un aller-retour inutile : personne ne
              cherche longtemps un bouton qui n'existe pas s'il sait pourquoi. */}
          Votre nom et votre adresse sont modifiés par l’administrateur de votre
          entreprise. Votre mot de passe, lui, n’appartient qu’à vous.
        </p>
      </section>

      <section className="carte">
        <div className="entete-section">
          <h3>Changer mon mot de passe</h3>
        </div>

        {erreur && <p className="erreur">{erreur}</p>}

        <form className="formulaire" onSubmit={changer}>
          <div className="grille-form">
            <ChampMotDePasse
              label="Mot de passe actuel"
              value={ancien}
              onChange={setAncien}
              autoComplete="current-password"
              required
            />
            <ChampMotDePasse
              label="Nouveau mot de passe"
              value={nouveau}
              onChange={setNouveau}
              autoComplete="new-password"
              required
            />
            <ChampMotDePasse
              label="Confirmer le nouveau"
              value={confirmation}
              onChange={setConfirmation}
              autoComplete="new-password"
              required
            />
          </div>
          <p className="sous-info">
            {AIDE_MOT_DE_PASSE} Vos autres sessions seront déconnectées — c’est
            le geste qu’on fait justement quand on soupçonne que quelqu’un
            d’autre connaît le sien.
          </p>
          <div className="actions-form">
            <button
              className="btn-accent"
              type="submit"
              disabled={enCours || !ancien || !nouveau || !confirmation}
            >
              {enCours ? "Changement…" : "Changer mon mot de passe"}
            </button>
          </div>
        </form>
      </section>
    </Layout>
  );
}
